import Styles from "./index.module.scss"

type PartitionLayout = {
    breakPartition: boolean;
    text?: string;
}

const Partition = ({ breakPartition , text } : PartitionLayout) => {
    return breakPartition?
    <div data-testid="partition" className={Styles['broken-partition']}>
        <span data-testid="partition-child" className={Styles['partition-line']}></span>
        <text data-testid="partition-child" className={Styles['partition-text']}>{text}</text>
        <span data-testid="partition-child"className={Styles['partition-line']}></span>
    </div>
    :
    <div data-testid="partition" className={Styles.partition}></div>;
}

export default Partition;